import Controller from '@ember/controller';

import { QontoHeader } from 'receivable-invoices-js/react/components/shared/qonto-header';

import styles from './styles.module.css';

export default class IndexController extends Controller {
  qontoHeader = QontoHeader;
  styles = styles;
}
